import {
  isValueNotEmptyMessage,
  isValueArrayNotDuplicate,
  isValueNotLong,
} from 'src/components/pages/PipelinesPages/utils/validators'

const maxJobNameLength = 100

export const jobNameValidators = [
  {
    validator: isValueNotEmptyMessage,
    message: 'Job name should not be empty',
  },
  {
    validator: isValueArrayNotDuplicate,
    message: 'This job name already exists',
  },
  {
    validator: isValueNotLong(maxJobNameLength + 1),
    message: `The job name must not exceed ${maxJobNameLength} characters`,
  },
]
